import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_SERVICE_AGREEMENT_UPLOAD} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const ServiceAgreementUpload = lazy(() =>
  import('../../../screens/ServiceAgreementUpload')
    .then(module => ({default: module.ServiceAgreementUpload})));

const BackendUpdateNavigation = [
  {
    path: ROUTE_SERVICE_AGREEMENT_UPLOAD,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ServiceAgreementUpload />
      </Suspense>
    ),
  },
];

export default BackendUpdateNavigation;
